export default new class Helper {
    ComputeRoutePrefix(prefix) {
        if (prefix == null || prefix == undefined || prefix == "")
        return "";
       if (prefix.endsWith("/"))
        return prefix.slice(0, -1);
       return prefix;
    }
}